import axios from 'axios';
import notification from 'antd/es/notification';
import { Cookies } from 'react-cookie';

// const apiRoot = __API_URL__;
const apiRoot = 'https://un-dev.qala-ai.com/api/v1';
export const cookies = new Cookies();

export const api = (auth = false, responseType) => {
  const options = {
    baseURL: apiRoot,
  };
  if (responseType) {
    options.responseType = responseType;
  }
  const axiosInstance = axios.create(options);

  if (auth) {
    const access_token = cookies.get('access_token');
    axiosInstance.defaults.headers = {
      Authorization: `Bearer ${access_token}`,
      'Access-Control-Expose-Headers': 'Content-Disposition',
    };
  }

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.request.status === 0) {
        notification.error({
          message: 'Ошибка',
          description: 'Ошибка сети',
          placement: 'topRight',
          className: 'notification',
        });
      } else if (error.response.status === 401) {
        cookies.remove('access_token', { path: '/' });
        window.location.replace('/login');
      }
      notification.error({
        message: error.response.statusText,
        description: error.response.data.message,
        placement: 'topRight',
        className: 'notification',
      });
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};
